module.exports = "<div class=\"home\">\n    <img src=\"assets/img/homepage-img.png\" />\n    <h1>Set apart by perfection</h1>\n\n\n    <h4>Built by <a href=\"http://globalbit.co.il\" target=\"_blank\">Globalbit<span>_</span></a></h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main